import React from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';

const NavBar = () => (
  <header className="masthead">
    <Link className="masthead-logo" to="/">
      <img src={`${process.env.PUBLIC_URL}/logo-mark.png`} alt="EditImagePro" />
    </Link>
    <nav className="masthead-nav">
      <Link className="eyebrow masthead-link" to="/privacy-policy">
        Privacy
      </Link>
      <a
        className="eyebrow masthead-link"
        href="https://buymeacoffee.com/siri"
        target="_blank"
        rel="noopener noreferrer"
      >
        Buy the creator a coffee
      </a>
    </nav>
  </header>
);

export default NavBar;
